module.exports = __webpack_public_path__ + "img/ilanlar-bg.af41fdac.jpg";